import { render, staticRenderFns } from "./appUpdate.vue?vue&type=template&id=9a1c3eb6&scoped=true"
import script from "./appUpdate.vue?vue&type=script&lang=js"
export * from "./appUpdate.vue?vue&type=script&lang=js"
import style0 from "./appUpdate.vue?vue&type=style&index=0&id=9a1c3eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1c3eb6",
  null
  
)

export default component.exports